import type { SAMAChat, XMPPChat } from './ConnectyCube';

export type { SAMAChat, XMPPChat };
export type * from './types';

import * as enums from './types/enums';
import ConnectyCube from './ConnectyCube';

export default Object.assign(new ConnectyCube<XMPPChat>(), { ConnectyCube, ...enums });
